import { TextInputField } from "@sainsburys-tech/luna-form";
import { Form } from "@sainsburys-tech/luna-form";
import { Container, GridItem, GridWrapper } from "@sainsburys-tech/luna-grid";
import { FC, useEffect, useState } from "react";
import {
  FIELDS,
  FormInputLevels,
  ProductGroupOptions,
} from "../../../Interfaces/Product/IProductFormField";
import { ProductFormProps } from "../../../Types/Product/ProductFormProps";
import ActionButton from "../../SharedComponents/ActionButton";
import FamilyGroupAutoComplete from "../../SharedComponents/FamilyGroupAutoComplete";
import { useSelector } from "react-redux";
import { SelectField } from "@sainsburys-tech/luna-form";
import { ProductTypeOptions } from "../../../Interfaces/IFamilyGroupFormField";
import { UI_CONSTANTS } from "../../../Constants/constants";

const HierarchyForm: FC<ProductFormProps> = (props) => {
  const [isFormDirty, setIsFormDirty] = useState<boolean | undefined>(
    props.dirty || true
  );
  const pageDirtyPayload = useSelector((state: any) => state.pageDirtyReducer);

  useEffect(() => {
    if (pageDirtyPayload.data !== null) {
      let compareResult =
        JSON.stringify(pageDirtyPayload.data.values) ===
        JSON.stringify(props.values);
      setIsFormDirty(compareResult);
    }
  }, [pageDirtyPayload]);

  return (
    <>
      <Container>
        <Form className="o-form">
          <GridWrapper className="ln-u-push-bottom">
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.sainId.name}
                label={FormInputLevels.SainId}
                maxLength={128}
                value={props.values.sainId}
                error={props.errors?.sainId}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
                disabled
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name="displayItemNumber"
                label={FormInputLevels.DisplayItemNumber}
                value={
                  props.values.skuNumber
                    ? props.values.skuNumber
                    : props.values.catNumber
                }
                disabled={true}
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <h4 style={{ fontSize: "1.125rem" }}>Family Group</h4>
              <FamilyGroupAutoComplete
                productType={props.values.productType}
                className="family-Group-AutoCompleteModal"
                name="FamilyGroupNew"
                placeholder="Please select"
                testid="autocomplete-field"
                initialValue={props.values.familyGroup || ""}
                onSelect={(e: any) => {
                  if (e === null || e?.value === null) {
                    e = {
                      label: props.values.familyGroup,
                      value: { desc: props.values.familyGroup },
                    };
                  }
                  props.onChange(e, e.label, e.value?.desc, false);
                }}
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.description.name}
                label={FormInputLevels.Description}
                maxLength={128}
                value={props.values.description}
                disabled={true}
              />
            </GridItem>
          </GridWrapper>
          <GridWrapper className="ln-u-push-bottom">
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.packSize.name}
                label={FormInputLevels.PackSize}
                value={
                  props.values.alias === UI_CONSTANTS.SAINSBURYS_SKU ||
                  props.values.alias === UI_CONSTANTS.SAINSBURYS_PACK
                    ? `CS${props.values.packSize}`
                    : props.values.alias === UI_CONSTANTS.ARGOS
                    ? (props.values.packSize == 1) ? `EA` : `CS${props.values.packSize}`
                    : props.values.packSize
                }
                disabled
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.productType.name}
                label={FormInputLevels.ProductType}
                value={props.values.productType}
                disabled={true}
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.businessUnit}
                label={FormInputLevels.BusinessUnit}
                maxLength={128}
                value={props.values.businessUnit}
                error={props.errors?.businessUnit}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
                disabled
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.superCategory}
                label={FormInputLevels.SuperCategory}
                maxLength={128}
                value={props.values.superCategory}
                error={props.errors?.superCategory}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
                disabled
              />
            </GridItem>
          </GridWrapper>
          <GridWrapper className="ln-u-push-bottom">
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.category}
                label={FormInputLevels.Category}
                maxLength={128}
                value={props.values.category}
                error={props.errors?.category}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
                disabled
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.subCategory.name}
                label={FormInputLevels.SubCategory}
                maxLength={128}
                value={props.values.subCategory}
                error={props.errors?.subCategory}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
                disabled
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.segment.name}
                label={FormInputLevels.Segment}
                maxLength={128}
                value={props.values.segment}
                error={props.errors?.segment}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
                disabled
              />
            </GridItem>
          </GridWrapper>
        </Form>
        <ActionButton
          onSubmit={props.onSubmit}
          onClearAll={props.onClearAll}
          onCancel={props.onCancel}
          isAddDisabled={isFormDirty}
          isDirty={props.dirty}
          isEdit={props.isEdit}
          isClearButtonRequired={false}
          submitted={props.submitted}
        />
      </Container>
    </>
  );
};

export default HierarchyForm;
